<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav"/>
    <div class="content">
      <div class="headerbg">
        <span>经济学实验教学平台</span>
        <b>ECONOMIC EXPERIMENT TEACHING PLATFORM</b>

      </div>
      <div class="mainbody">
        <div class="setionbox">
        <p>《经济学实验教学系统》的实验项目根据经济学（包括宏观经济学和微观经济学）的十大重点理论，设计相应的实验，让学员掌握经济学理论知识，并学会运用知识解决现实经济问题。</p>
      </div>
      <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>宏观经济学实验</p>
            <div class="line"></div>
            <div class="text">利用经济增长分析、货币创造、就业和通货膨胀、财政政策、国际贸易比较优势5种类型的实验来对宏观经济学的经济总量、总需求与总供给、国民收入总量及构成、货币与财政、人口与就业、要素与禀赋、经济周期与经济增长、经济预期与经济政策、国际贸易与国际经济等宏观经济现象进行综合性研究。</div>
          </div>
          <div class="right"><img  style="width:574px; "src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/EconomicExperimentTeachingPlatform/img1.png" alt=""></div>
        </div>
      </div>

        <div class="setionbox">
        <div class="setion">

          <div class="right"><img  style="width:544px; "src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/EconomicExperimentTeachingPlatform/img2.png" alt=""></div>
          <div class="left">
            <p>微观经济学实验</p>
            <div class="line"></div>
            <div class="text">根据市场供求均衡、消费者行为理论、生产者行为理论、完全垄断市场、市场失灵等5种实验的结果，对个体经济单位的经济行为，以及相应的经济变量的单项数值如何决定经济学说而进行的研究。</div>
          </div>
        </div>
      </div>


      </div>
    </div>
    <Footer/>

  </div>
</template>

<script>
export default {
  name: 'EconomicExperimentTeachingPlatform',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  p {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .line {
    margin-top: 20px;
    width: 120px;
    height: 4px;
    background: #f39a21;
  }
  .text {
    width: 468px;
    margin-top: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
     line-height: 1.8;
  }
}
.right {
  flex: 1;
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("~https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/EconomicExperimentTeachingPlatform/headerbgi.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
  }
}
.mainbody>.setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1069px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/EconomicExperimentTeachingPlatform.vue